import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AdminUser, AdminUserPost } from 'src/types/shared/AdminUser';
import { ChallengeApplicationResponse } from 'src/types/shared/Challenge';

export const updateAdminUserRequest = createAction('updateAdminUserRequest');
export const updateAdminUserSuccess = createAction<AdminUserPost>('updateAdminUserSuccess');
export const updateAdminUserFailure = createAction('updateAdminUserFailure');

export const updateAdminUser = (id: number, postbody: AdminUserPost) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(updateAdminUserRequest());
    try {
        const { data }: UpdateAdminResponse = await api.patch(`admin/admins/${id}`, postbody);
        dispatch(updateAdminUserSuccess(data.user));
    } catch (e) {
        handleApiErrors(dispatch, updateAdminUserFailure, e);
    }
};

interface AdminUserResponse {
    user: AdminUser;
    challengeApplications: ChallengeApplicationResponse[];
}
interface UpdateAdminResponse {
    data: AdminUserResponse;
}
